import { getPageType } from '~/events/utils/pageType'
import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

eventBus.$on(eventDefinitions.SITE.PAGE_VIEW, ({ page_route_name, page_url, page_url_referrer }) => {
  const pageLocation = page_url || window.location.href
  const pageReferrer = page_url_referrer || document.referrer

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'page',
    page: {
      page_location: pageLocation,
      page_referrer: pageReferrer,
      lang: 'cs',
      page_type: getPageType(),
    },
  })
})
